import { useContext } from 'react';
import ToastContext from 'ui/contexts/overlay/Toast';

export default function useToastContext() {
  return useContext(ToastContext);
}
